import { combineReducers } from 'redux'
import inviting from './inviting'

export default combineReducers({
  inviting,
})
